import { Button, Drawer, Input, InputNumber } from "antd";
import {
  KeyConfig,
  StatusWorking,
  TableSessionStatus,
  UserPlan,
} from "../../constants/enum";
import React, { FC, useCallback, useContext, useEffect, useState } from "react";
import {
  checkHaveTableSessionNotDone,
  getListStaffDuplicate,
} from "../../api/tableSession";
import { getListConfig, updateEntropy } from "../../api/table";
import { handleErrorMessage, logout } from "../../utils/helper/common";
import { queryKeys, router } from "../../constants/constans";
import { useMutation, useQuery, useQueryClient } from "react-query";

import CaretIcon from "../../assets/images/caretRight.svg";
import Cookies from "js-cookie";
import CustomNotification from "Component/CustomNotification";
import ModalConfirm from "../Modal/ModalConfirm";
import ModalDuplicateStaff from "../Modal/ModalDuplicateStaff";
import ModalEditTable from "../Modal/ModalEditTable";
import ModalExportCsv from "../Modal/ModalExportCsv";
import ModalSettingDefault from "../Modal/ModalSettingDefault";
import { ModalStaffConfig } from "../ModalStaffConfig";
import ModalTableHistory from "../Modal/ModalTableHistory";
import ModalViewStaff from "Component/Modal/ModalViewStaff";
import classNames from "classnames";
import { history } from "App";
import { logoutApi } from "../../api/authentication";
import moment from "moment";
import styles from "./style.module.scss";
import { useDebounce } from "use-debounce";
import useIsMobile from "../../hooks/useIsMobile";
import useNetworkStatus from "hooks/useNetworkStatus";

interface IProps {
  listTableSession?: any;
}
export function Footer(props: IProps) {
  const { listTableSession } = props;
  const [showStaffModal, setStaffModal] = useState<boolean>(false);
  const [showModalConfirmLogout, setShowModalConfirmLogout] =
    useState<boolean>(false);

  const ShowStaffModal = useCallback(() => setStaffModal(true), []);
  const [showModalSettingDefault, setShowModalSettingDefault] =
    useState<boolean>(false);
  const [showModalExport, setShowModalExport] = useState<boolean>(false);
  const [showModalViewStaff, setShowModalViewStaff] = useState<boolean>(false);

  const [showModalDuplicate, setShowModalDuplicate] = useState<boolean>(false);
  const [showModalEditTable, setShowModalEditTable] = useState<boolean>(false);
  const [modalEditTableHistory, showModalEditTableHistory] =
    useState<boolean>(false);
  const [entropy, setEntropy] = useState<number>(0);
  const [entropyResult, setEntropyResult] = useState<number>(0);
  const queryClient = useQueryClient();
  const [debounceKeyword] = useDebounce(entropy, 500);
  const [openDrawer, setOpenDrawer] = useState(false);

  const userPlan = Cookies.get("userPlan");

  const isOnline = useNetworkStatus();
  const { data: defaultConfig } = useQuery(queryKeys.defaultConfigTable);
  const { isMobile } = useIsMobile();

  const updateEntropyAction = useMutation(updateEntropy);
  useQuery(queryKeys.listConfig, getListConfig, {
    onSuccess: (data) => {
      if (Array.isArray(data?.data)) {
        const configEntropy = data?.data?.find(
          (item: any) => item?.key === KeyConfig.ENTROPY_INPUT
        );
        if (!!configEntropy) {
          setEntropy(Number(configEntropy?.value) || 0);
        }
      }
    },
  });

  const { data: listHost } = useQuery(queryKeys.listHost) as any;

  useEffect(() => {
    if (
      !!listHost?.data &&
      Array.isArray(listHost?.data) &&
      listTableSession?.data &&
      Array.isArray(listTableSession?.data)
    ) {
      const totalHostWork = listHost?.data?.filter(
        (item: any) =>
          item?.infoWorking?.statusWorking === StatusWorking.Working
      );

      const totalHime = listTableSession?.data?.reduce(
        (total: number, item: any) => {
          // Chỉ cộng khi status là "start"
          if (item?.status !== TableSessionStatus.End) {
            return total + (Number(item?.tableConfig?.hime) || 0);
          }
          return total; // Giữ nguyên tổng nếu không thỏa điều kiện
        },
        0
      );
      setEntropyResult(totalHostWork?.length - totalHime - entropy);
    }
  }, [
    listTableSession?.data?.length,
    listTableSession,
    listHost,
    debounceKeyword,
  ]);

  useEffect(() => {
    updateEntropyAction.mutate({ entropy: debounceKeyword || 0 });
  }, [debounceKeyword]);

  const { data: checkTableNotDone, refetch } = useQuery(
    queryKeys.checkTableNotDone,
    checkHaveTableSessionNotDone
  );
  const { data: listStaffDuplicate } = useQuery(
    queryKeys.listStaffDuplicate,
    getListStaffDuplicate
  );

  const logoutAction = useMutation(logoutApi);
  const handleLogout = (isConfirm?: boolean) => {
    if (!isOnline) {
      CustomNotification({
        type: "error",
        message: "",
        description: "現在オフラインのため、シフトを終了できません。",
      });
      return;
    }
    refetch();
    if (!!isConfirm) {
      if (Number(userPlan) === UserPlan.SubAccount) {
        Cookies.remove("userPlan");
        Cookies.remove("token");
        Cookies.remove("refreshToken");
        return;
      }
      if (!!checkTableNotDone?.data) {
        setShowModalConfirmLogout(false);
        return;
      }

      logoutAction.mutate(
        {},
        {
          onError: (err) => {
            logout();
          },
          onSuccess: (data) => {
            logout();
          },
        }
      );
    }
    setShowModalConfirmLogout(true);
  };

  const handleShowModalSettingDefault = () => {
    setShowModalSettingDefault(true);
  };

  const handleShowModalExport = () => {
    setShowModalExport(true);
  };

  const handleShowModalViewStaff = () => {
    setShowModalViewStaff(true);
  };

  const handleShowModalDuplicate = () => {
    setShowModalDuplicate(true);
  };

  const handleShowModalEditTable = () => {
    setShowModalEditTable(true);
  };

  const handleShowModalTableHistory = () => {
    showModalEditTableHistory(true);
  };

  const handleChangeEntropy = (value: number | null) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }
    if (value && value < 1) return;
    setEntropy(value || 0);
  };

  const handleNavigateHome = () => {
    if (window.location.pathname === router.Home.Origin) return;
    history.push(router.Home.Origin);
  };
  return (
    <>
      <ModalStaffConfig
        showStaffModal={showStaffModal}
        setStaffModal={setStaffModal}
      />
      <ModalConfirm
        isVisible={showModalConfirmLogout}
        title={
          !!checkTableNotDone?.data && Number(userPlan) !== UserPlan.SubAccount
            ? "終了していない卓があるので、ログアウトできません。"
            : "ログアウトしてもよろしいですか？"
        }
        textCancel={"いいえ"}
        textOke={"はい"}
        header="営業終了"
        handleClose={() => setShowModalConfirmLogout(false)}
        handleCancel={() => setShowModalConfirmLogout(false)}
        handleOke={() => handleLogout(true)}
        closeIcon={false}
      />
      <ModalSettingDefault
        isVisible={showModalSettingDefault}
        handleCancel={() => setShowModalSettingDefault(false)}
      />

      <ModalExportCsv
        isVisible={showModalExport}
        handleCancel={() => setShowModalExport(false)}
      />

      <ModalViewStaff
        isVisible={showModalViewStaff}
        handleCancel={() => setShowModalViewStaff(false)}
      />

      <ModalDuplicateStaff
        isVisible={showModalDuplicate}
        handleCancel={() => setShowModalDuplicate(false)}
      />

      <ModalEditTable
        isVisible={showModalEditTable}
        handleCancel={() => setShowModalEditTable(false)}
      />

      {!!modalEditTableHistory && (
        <ModalTableHistory
          isVisible={modalEditTableHistory}
          handleCancel={() => showModalEditTableHistory(false)}
        />
      )}
      <footer
        className={classNames("no-zoom", {
          [styles.inMobile]: !!isMobile,
          [styles.subAccount]: Number(userPlan) === UserPlan.SubAccount,
        })}
      >
        <div className="container">
          <div className={styles.infoContainer}>
            <div className={styles.logo} onClick={() => handleNavigateHome()}>
              <span> 初回付け回しアプリ</span>
              <div>内勤革命</div>
              {!isMobile && (
                <div className={styles.dateInfo}>
                  <div className={styles.title}>ログイン日: </div>
                  <div>{moment().format("YYYY/MM/DD")}</div>
                </div>
              )}
            </div>
            {!!(defaultConfig as any)?.data?.showEntropy && (
              <div className={styles.entropyContainer}>
                {Number(userPlan) !== UserPlan.SubAccount && (
                  <div className={styles.title}>指名客数</div>
                )}
                <div className={styles.contentContainer}>
                  {Number(userPlan) !== UserPlan.SubAccount && (
                    <div
                      className={styles.control}
                      onClick={() => handleChangeEntropy(entropy - 1)}
                    >
                      -
                    </div>
                  )}
                  {Number(userPlan) !== UserPlan.SubAccount && (
                    <InputNumber
                      className={styles.entropyInput}
                      controls={false}
                      value={entropy}
                      onChange={handleChangeEntropy}
                      readOnly
                      min={0}
                    />
                  )}

                  {Number(userPlan) !== UserPlan.SubAccount && (
                    <div
                      className={styles.control}
                      onClick={() => handleChangeEntropy(entropy + 1)}
                    >
                      +
                    </div>
                  )}

                  <div className={styles.currentEntropy}>
                    {Number(userPlan) !== UserPlan.SubAccount && (
                      <img src={CaretIcon} className={styles.caretIcon} />
                    )}
                    <span className={styles.symbol}>
                      {entropyResult > 0 ? "+" : "-"}
                    </span>

                    <span>{Math.abs(entropyResult)}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {!isMobile ? (
            <ul className={classNames("menu", styles.menu)}>
              {Number(userPlan) !== UserPlan.SubAccount && (
                <li onClick={handleShowModalSettingDefault}>基本設定</li>
              )}
              <li onClick={handleShowModalDuplicate}>
                重複状況
                {!!listStaffDuplicate?.data?.length && (
                  <span className={styles.marker}>
                    {listStaffDuplicate?.data?.length}
                  </span>
                )}
              </li>
              {Number(userPlan) !== UserPlan.SubAccount && (
                <li onClick={ShowStaffModal}>スタッフ管理</li>
              )}

              <li onClick={handleShowModalViewStaff}>スケジュール </li>

              {Number(userPlan) !== UserPlan.SubAccount && (
                <li onClick={() => handleShowModalEditTable()}>
                  タイムテーブル
                </li>
              )}
              <li onClick={() => handleShowModalTableHistory()}>データ修正</li>

              {Number(userPlan) !== UserPlan.SubAccount && (
                <li onClick={handleShowModalExport}>データ集計</li>
              )}

              <li onClick={() => handleLogout()}>営業終了</li>

              {/* <li>送り履歴</li> */}
            </ul>
          ) : (
          <ul className={classNames("menu", styles.menu, styles.menuMobile)}>
              {Number(userPlan) !== UserPlan.SubAccount && <li onClick={handleShowModalDuplicate}>
                重複状況
                {!!listStaffDuplicate?.data?.length && (
                  <span className={styles.marker}>
                    {listStaffDuplicate?.data?.length}
                  </span>
                )}
              </li>}
              <li onClick={handleShowModalViewStaff}>スケジュール </li>
            </ul>
          )}
        </div>
      </footer>
    </>
  );
}
